<div class="tag offer" *ngIf="showTagOffer">
  <img
    class="petal"
    src="/assets/svg/icon-discount-yellow.svg"
    [ngClass]="{'petal--suggest': suggestCard}"
    [alt]="altText"
  />
  <p class="text text--from" *ngIf="isMobileGroup">Hasta</p>
  <p class="text" [ngClass]="{'text--suggest': suggestCard}">{{ offerText }}</p>
</div>

<div class="tag offer" *ngIf="showTagOfferPrime && !isSuggest">
  <app-prime-petal-long
    [customClasses]="'prime-petal-long--percentage'"
    [value]="primeTextDiscount"
    [isDetail]="false"
    [group]="groupClass"
  ></app-prime-petal-long>
</div>

<div class="tag__online-only hide" *ngIf="onlyOnline">
  <img
    class="tag__online-only--petal"
    src="/assets/svg/onlyOnline.svg"
    alt="Disponible para comprar solo en línea"
    title="Solo Online"
  />
</div>

<span
  *ngIf="noPrimePetal && offerText"
  class="price__petal-offer"
  [class.price__petal-offer--suggest-half]="isHalf"
>
  <img
    class="petal"
    src="/assets/svg/icon-discount-yellow.svg"
    [alt]="altText"
  />
  <p class="text">{{ offerText }}</p>
</span>
